import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SvgIcons from './icons'
import ElementUI from 'element-ui'
import Vue2Editor from 'vue2-editor'
import filters from './filter/index'
import DictData from './components/DictData'
import I18n from './i18n'
// Vue自定义指令
import directive from './directive'
import './permission'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'nprogress/nprogress.css'
import './style/scss/index.scss'
import './style/css/style.css'
import './style/scss/workspace-theme.scss'

import { resetForm } from './utils/common'
import { getDictDataByType } from './api/system/dict-data'

// Keep fixed app shells aligned with the visible mobile viewport. Mobile
// browsers may report a 100vh that includes the address bar or gesture area.
const syncViewportHeight = () => {
  const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight
  document.documentElement.style.setProperty('--app-viewport-height', `${viewportHeight}px`)
}

syncViewportHeight()
window.addEventListener('resize', syncViewportHeight)
window.addEventListener('orientationchange', syncViewportHeight)
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', syncViewportHeight)
}

Vue.use(directive)
Vue.use(ElementUI)
Vue.use(SvgIcons)
Vue.use(Vue2Editor)
Vue.use(I18n)

// 全局挂载方法
Vue.prototype.resetForm = resetForm
Vue.prototype.getDictDatas = getDictDataByType

DictData.install()

// 时间过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
